var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgModalClose = function SvgModalClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 0c-8.83694084 0-16 7.16269841-16 16 0 8.8373016 7.16161616 16 16 16 8.8340548 0 16-7.1616162 16-16 0-8.83694084-7.1655844-16-16-16zm7.5079365 21.8394661c.5157648.5129509.5157648 1.3457792 0 1.861544-.5129509.5157648-1.3471861.5157648-1.860101 0l-5.6479077-5.6493506-5.6479076 5.6493506c-.51295094.5157648-1.34718615.5157648-1.86010101 0-.51576479-.5157648-.51576479-1.3471861 0-1.861544l5.83838381-5.8398269-5.83838381-5.8398268c-.51576479-.51295093-.51576479-1.34296536 0-1.861544.51295094-.51295094 1.34718615-.51295094 1.86010101 0l5.6464646 5.6493506 5.6493507-5.6493506c.5129509-.51295094 1.3471861-.51295094 1.860101 0 .5157648.51576479.5157648 1.34859307 0 1.861544l-5.8383838 5.8398268z",
    fill: "#df542f"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModalClose, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/ModalClose.43dc84c5.svg";
export { ForwardRef as ReactComponent };